export const defaultIsLoading = {
  readCaptivePortal: false,
  removeCaptivePortal: false,
  readUserProfile: false,
  readRadiusProfile: false,
  readLdapProfile: false,
  readWhitelist: false,
  readDefaultSplashPageConfig: false,
}

export const defaultAlertInfo = {
  open: false,
  severity: "",
  message: "",
};

export const captivePortalConfig = {
  profileName: null,
  authTypeList: [
    {
      label: 'Click Through',
      value: 'CLICK_THROUGH',
      isActive: true,
    },
    {
      label: 'User Name & Password',
      value: 'USERNAME_PASSWORD',
      isActive: false,
    },
    // {
    //   label: 'Voucher',
    //   value: 'VOUCHER',
    //   isActive: false,
    // },
    {
      label: 'Remote RADIUS',
      value: 'REMOTE_RADIUS',
      isActive: false,
    },
    {
      label: 'LDAP',
      value: 'LDAP',
      isActive: false,
    },
    {
      label: 'MAC Address',
      value: 'MAC_ADDRESS',
      isActive: false,
    },
    {
      label: 'External Captive Portal',
      value: 'EXTERNAL_CAPTIVE_PORTAL',
      isActive: false,
    },
  ],
  simultaneousLoginOption: 'ENABLE', // ENABLE / DISABLE
  idleTimeoutOption: 'DEFAULT', // DEFAULT / CUSTOM
  idleTimeoutList: [
    {
      label: '30 Mins',
      value: 30,
      isActive: false,
    },
    {
      label: '60 Mins',
      value: 60,
      isActive: true,
    },
  ],
  idleTimeoutLabel: 5,
  authTimeoutOption: 'DISABLE', // DISABLE / ENABLE / CUSTOM
  authTimeoutList: [
    {
      label: '1 Hour',
      value: 60,
      isActive: true,
    },
    {
      label: '8 Hours',
      value: 480,
      isActive: false,
    },
    {
      label: '1 Day',
      value: 1440,
      isActive: false,
    },
  ],
  authTimeoutLabel: 5,
  authPerDayOption: 'CUSTOM', // CUSTOM / UNLIMIT
  authPerDayLabel: 1,
  reAuthIntervalOption: 'DISABLE', // DISABLE / ENABLE / CUSTOM
  reAuthIntervalList: [
    {
      label: '15 Mins',
      value: 15,
      isActive: true,
    },
    {
      label: '30 Mins',
      value: 30,
      isActive: false,
    },
  ],
  reAuthIntervalLabel: 10,
  userProfileList: [
    {
      label: 'No Profile',
      value: '',
      isActive: true,
    },
  ],
  radiusProfileList: [
    {
      label: 'No Profile',
      value: '',
      isActive: true,
    },
  ],
  ldapProfileList: [
    {
      label: 'No Profile',
      value: '',
      isActive: true,
    },
  ],
  externalCaptivePortalProtocol: 'http', // http / https
  externalCaptivePortalLabel: null,
  landingPageOption: 'NO_SPECIFIC', // NO_SPECIFIC / CUSTOM
  landingPageUrlProtocol: 'http', // http / https
  landingPageUrlLabel: null,
  whitelistList: [
    {
      label: 'Select',
      value: '',
      isActive: true,
    },
  ],
  preAuthAccessOption: 'DISABLE', // ENABLE / DISABLE
  walledGardenList: [{ label: '', value: '' }],
};

export const authTypeConfig = {
  CLICK_THROUGH: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: true,
    authPerDay: true,
    reAuthInterval: true,
    userProfile: false,
    radiusProfile: false,
    ldapProfile: false,
    externalCaptivePortal: false,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
  USERNAME_PASSWORD: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: true,
    authPerDay: true,
    reAuthInterval: true,
    userProfile: true,
    radiusProfile: false,
    ldapProfile: false,
    externalCaptivePortal: false,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
  VOUCHER: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: false,
    authPerDay: false,
    reAuthInterval: false,
    userProfile: false,
    radiusProfile: false,
    ldapProfile: false,
    externalCaptivePortal: false,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
  REMOTE_RADIUS: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: true,
    authPerDay: true,
    reAuthInterval: true,
    userProfile: false,
    radiusProfile: true,
    ldapProfile: false,
    externalCaptivePortal: false,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
  LDAP: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: true,
    authPerDay: true,
    reAuthInterval: true,
    userProfile: false,
    radiusProfile: false,
    ldapProfile: true,
    externalCaptivePortal: false,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
  MAC_ADDRESS: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: false,
    authPerDay: false,
    reAuthInterval: false,
    userProfile: false,
    radiusProfile: true,
    ldapProfile: false,
    externalCaptivePortal: false,
    landingPage: false,
    whitelist: true,
    preAuthAccess: true,
  },
  EXTERNAL_CAPTIVE_PORTAL: {
    simultaneousLogin: true,
    idleTimeout: true,
    authTimeout: false,
    authPerDay: false,
    reAuthInterval: false,
    userProfile: false,
    radiusProfile: false,
    ldapProfile: false,
    externalCaptivePortal: true,
    landingPage: true,
    whitelist: true,
    preAuthAccess: true,
  },
};

const cloneListWithActiveDefault = (list, defaultList) => {
  if (!list?.length || list.every(item => !item.isActive)) {
    return defaultList.map(item => ({ ...item }));
  }
  return list;
};

export const applyAuthTypeFieldDefaults = (formData, authType) => {
  const settings = authTypeConfig[authType] ?? {};
  const defaults = captivePortalConfig;

  if (settings.simultaneousLogin && formData.simultaneousLoginOption == null) {
    formData.simultaneousLoginOption = defaults.simultaneousLoginOption;
  }

  if (settings.idleTimeout) {
    if (formData.idleTimeoutOption == null) {
      formData.idleTimeoutOption = defaults.idleTimeoutOption;
    }
    formData.idleTimeoutList = cloneListWithActiveDefault(formData.idleTimeoutList, defaults.idleTimeoutList);
    if (formData.idleTimeoutLabel == null) {
      formData.idleTimeoutLabel = defaults.idleTimeoutLabel;
    }
  }

  if (settings.authTimeout) {
    if (formData.authTimeoutOption == null) {
      formData.authTimeoutOption = defaults.authTimeoutOption;
    }
    formData.authTimeoutList = cloneListWithActiveDefault(formData.authTimeoutList, defaults.authTimeoutList);
    if (formData.authTimeoutLabel == null) {
      formData.authTimeoutLabel = defaults.authTimeoutLabel;
    }
  }

  if (settings.authPerDay) {
    if (formData.authPerDayOption == null) {
      formData.authPerDayOption = defaults.authPerDayOption;
    }
    if (formData.authPerDayLabel == null) {
      formData.authPerDayLabel = defaults.authPerDayLabel;
    }
  }

  if (settings.reAuthInterval) {
    if (formData.reAuthIntervalOption == null) {
      formData.reAuthIntervalOption = defaults.reAuthIntervalOption;
    }
    formData.reAuthIntervalList = cloneListWithActiveDefault(formData.reAuthIntervalList, defaults.reAuthIntervalList);
    if (formData.reAuthIntervalLabel == null) {
      formData.reAuthIntervalLabel = defaults.reAuthIntervalLabel;
    }
  }

  if (settings.userProfile) {
    formData.userProfileList = cloneListWithActiveDefault(formData.userProfileList, defaults.userProfileList);
  }

  if (settings.radiusProfile) {
    formData.radiusProfileList = cloneListWithActiveDefault(formData.radiusProfileList, defaults.radiusProfileList);
  }

  if (settings.ldapProfile) {
    formData.ldapProfileList = cloneListWithActiveDefault(formData.ldapProfileList, defaults.ldapProfileList);
  }

  if (settings.externalCaptivePortal) {
    if (formData.externalCaptivePortalProtocol == null) {
      formData.externalCaptivePortalProtocol = defaults.externalCaptivePortalProtocol;
    }
    if (formData.externalCaptivePortalLabel == null) {
      formData.externalCaptivePortalLabel = defaults.externalCaptivePortalLabel ?? '';
    }
  }

  if (settings.landingPage) {
    if (formData.landingPageOption == null) {
      formData.landingPageOption = defaults.landingPageOption;
    }
    if (formData.landingPageUrlProtocol == null) {
      formData.landingPageUrlProtocol = defaults.landingPageUrlProtocol;
    }
    if (formData.landingPageUrlLabel == null) {
      formData.landingPageUrlLabel = defaults.landingPageUrlLabel ?? '';
    }
  }

  if (settings.whitelist) {
    formData.whitelistList = cloneListWithActiveDefault(formData.whitelistList, defaults.whitelistList);
  }

  if (settings.preAuthAccess) {
    if (formData.preAuthAccessOption == null) {
      formData.preAuthAccessOption = defaults.preAuthAccessOption;
    }
    if (!formData.walledGardenList?.length) {
      formData.walledGardenList = defaults.walledGardenList.map(item => ({ ...item }));
    }
  }
};
